<template>
<b-modal
      v-model="modalShow"
      centered
      title="Create Wallet"
      hide-footer
      no-close-on-backdrop
    >
    <b-overlay :show="loadingData" variant="transparent" no-wrap />
 
    <validation-observer ref="simpleRules">
      <b-form>
        <b-row>
          <b-col md="12">
            <b-form-group label="Users">
              <validation-provider
              #default="{ errors }"
              name="user"
              rules="required">
              <v-select
                  v-model="form.user"
                  placeholder="Users"
                  label="username"
                  :options="dataUsers"/>
              <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
          </b-form-group>

          <b-form-group label="Currencies">
              <validation-provider
              #default="{ errors }"
              name="currency"
              rules="required">
              <v-select
                  v-model="form.currencies"
                  placeholder="Currencies"
                  label="abbreviation"
                  multiple
                  :options="datacurrencys"/>
              <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
          </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              @click.prevent="validationForm">
              Add
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
</b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BCardText, VBModal, BCard, BOverlay
} from 'bootstrap-vue'
import { required, integer } from '@validations'
import { mapActions  } from 'vuex'
import { BFormCheckbox } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCardText,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    BCard,
    vSelect,
    VBModal,
    BOverlay,
    ToastificationContent
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
        modalShow: false,
      datacurrencys: [],
      dataUsers: [],
      dataProducts: [],
      form: {
        user: null,
        currencies: [],
        details: {},
      }, 
      formData: {
        user: null,
        currencies: [],
        details: {},
      },    
      required,
      integer,
      loadingData: false
    }
  },
  watch:{
    modalShow(val){
      if(val){
        this.getCurrencies()
        this.getUsers()
      }
    }
  },
  methods: {
    ...mapActions('wallet', ['store', 'wallets']),
    ...mapActions('currency', ['currencys']),
    ...mapActions('user', ['users']),

    async validationForm() {
      this.$refs.simpleRules.validate()
      .then(async (success) => {
        if (success) {
          this.formData.userId = this.form.user._id
          this.formData.currencies = this.form.currencies.map(item => {
            return item.abbreviation
          })

          try {
            this.loadingData = true
             await this.store(this.formData)
             this.$emit('addWallet')
             this.resetFormData()
             this.$toast({
               component: ToastificationContent,
                props: {
                  title: "wallet added successfully",
                  icon: "CheckCircleIcon",
                  variant: "success",
                },
              });
             this.modalShow = false

          } catch (error) {
            console.log(error)
          }finally{
            this.loadingData = false
          }   
        }
      })
      .catch((error) => {
        this.$swal({
          title: 'Error!',
          text: error.message,
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      })
    },
    resetFormData(){
      this.form = {
        user: null,
        currencies: [],
        details: {},
      }
    },
    async getCurrencies() {
      this.datacurrencys = await this.currencys()
    },
    async getUsers() {
      this.dataUsers = await this.users()
    },
  },
}
</script>
